import {  object } from "prop-types";
import { observer } from "mobx-react";
import { getDateKey } from "@repo/structure";
import { useEstimateStructure, useEstimateTableSettings } from "@tools";
import { getTimelineCellPeriods } from "@tools/EstimateEditor/utils";
import { BillingChartBar } from "./BillingChartBar/BillingChartBar";
import { TimelineScaffoldCell } from "./TimelineScaffoldCell";
import useStyle from "./TimelineCells.style";
import classnames from "classnames";

export const TimelineBillingCell = observer(({ month }) => {
  const classes = useStyle();
  const structure = useEstimateStructure();
  const { setOpenedCharts } = useEstimateTableSettings();

  if (!month?.total) return <TimelineScaffoldCell month={month} />;

  const expandedMonths = structure.settings.timelineExpandedMonths;
  const periodValues = getTimelineCellPeriods(month, expandedMonths);

  return (
    <>
      {periodValues.map((period) => {
        const values = structure.workTypes
          .map((workType) => ({
            id: workType.id,
            value: period?.byWorkType?.[workType.id] || 0,
            hours: workType.workload || 0,
            name: workType.name,
            color: workType.timelineColor,
            fontColor: workType.timelineFontColor,
          }))
          .filter((value) => value.value > 0);

        return (
          <div
            key={getDateKey(period.startDate)}
            className={classnames(classes.cell, classes.cellBilling)}
          >
            {values.length > 0 && (
              <BillingChartBar values={values} onOpen={setOpenedCharts} />
            )}
          </div>
        );
      })}
    </>
  );
});

TimelineBillingCell.propTypes = {
  month: object.isRequired,
}
